import React from "react"
import PropTypes from "prop-types"
// Styles
import { Wrapper } from "./Button.styles"

const Button = ({ text, callback, disabled, submit, width }) => (
    <Wrapper
        type={submit ? "submit" : "button"}
        onClick={callback}
        disabled={disabled}
        width={width ? width : "50"}
    >
        {text}
    </Wrapper>
)

Button.propTypes = {
    text: PropTypes.string,
    callback: PropTypes.func,
    disabled: PropTypes.bool,
    submit: PropTypes.bool,
    width: PropTypes.number
}

export default Button